import { Route, Routes } from 'react-router-dom';
import { Home } from './pages/Home';
import { CollectionScanPage } from './pages/CollectionScanPage';
import { ScanPage } from './pages/ScanPage';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { Pricing } from './pages/Pricing';
import { Refunds } from './pages/Refunds';
import { Contact } from './pages/Contact';
import { LearnMore } from './pages/LearnMore';
import { RequestAccess } from './pages/RequestAccess';

export const App = () => (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/a/:publicSlug" element={<ScanPage />} />
    <Route path="/m/:collectionSlug" element={<CollectionScanPage />} />
    <Route path="/privacy" element={<Privacy />} />
    <Route path="/terms" element={<Terms />} />
    <Route path="/pricing" element={<Pricing />} />
    <Route path="/refunds" element={<Refunds />} />
    <Route path="/contact" element={<Contact />} />
    <Route path="/learn-more" element={<LearnMore />} />
    <Route path="/request-access" element={<RequestAccess />} />
    <Route path="/signup" element={<RequestAccess />} />
    <Route path="/register" element={<RequestAccess />} />
  </Routes>
);
